module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_prebuilt_customizable_themes.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_prebuilt_customizable_themes.png
// module id = 6iTW
// module chunks = 0